import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const AuthRoute = props => {
  const { token, redirect, from } = props;

  const pathname = () => {
    if (!token) {
      return '/no-access';
    }

    return redirect;
  };

  const state = { from };

  return token
    ? <Outlet />
    : <Navigate to={pathname()} state={state} />;
};

export { AuthRoute };